export const checkScrollAtTop = (containerDiv, scrollThreshold = 5) => {
  return containerDiv.scrollTop < scrollThreshold;
};
